import { Module } from "vuex";
import state, { OnboardingState } from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import RootState from "@/legacy/store/rootState";

const onboardingModule: Module<OnboardingState, RootState> = {
  actions,
  state,
  getters,
  mutations,
};

export default onboardingModule;
